/* eslint no-console: 0 */
/* global axios */
/* eslint no-undef: "error" */
/* eslint no-unused-expressions: ["error", { "allowShortCircuit": true }] */
import endPoints from './endPoints';

export default {
  fetchFacebookPages(token, accountId) {
    const urlData = endPoints('fetchFacebookPages');
    urlData.params.omniauth_token = token;
    return axios.post(urlData.url(accountId), urlData.params);
  },
  fetchPhoneNumberDetails({ phone_number_id, access_token, accountId, fields }) {
    return axios.get(`api/v1/accounts/${accountId}/channels/whatsapp_channel/phone_number_details`, {
      params: {
        phone_number_id,
        access_token,
        fields
      },
    });
  },
  exchangeAccessToken({ accountId, access_token }) {
    return axios.post(
      `/api/v1/accounts/${accountId}/channels/whatsapp_channel/exchange_access_token`,
      { access_token }
    );
  },
};
